import { render, staticRenderFns } from "./ChangeLogAction.vue?vue&type=template&id=c43de1fc&scoped=true&"
import script from "./ChangeLogAction.vue?vue&type=script&lang=ts&"
export * from "./ChangeLogAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43de1fc",
  null
  
)

export default component.exports